/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type PlaylistTypeCell_DisplayFragment = { __typename: 'Display', playlistType?: Types.PlaylistType | null };

export const PlaylistTypeCell_DisplayFragmentDoc = gql`
    fragment PlaylistTypeCell_display on Display {
  playlistType
}
    `;